import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

type Props = {
  title: string;
  /** One line under the title, for a caveat the title cannot carry. */
  note?: string;
  children: ReactNode;
  className?: string;
};

/**
 * Card chrome for the three configuration panels on this page.
 *
 * Deliberately not `src/components/SectionCard` — that one is a different card
 * (rounded-2xl, bordered, scroll-capped body) used by the dashboard summaries.
 */
const PanelCard = ({ title, note, children, className }: Props) => (
  <section className={cn('p-6 rounded-lg bg-theme-slate-800', className)}>
    <div className="mb-5">
      <h4 className="text-xl font-semibold text-white">{title}</h4>
      {note && <p className="text-xs text-white/40 mt-1">{note}</p>}
    </div>
    {children}
  </section>
);

export default PanelCard;
